import React from "react"
import { Message } from "@locmod/intl"
import { constants } from "helpers"

import messages from "./messages"
import { Href } from "components/navigation"

const items = [
  {
    text: messages.nav.about,
    link: constants.links.about,
  },
  {
    text: messages.nav.blog,
    link: constants.links.blog,
  },
  {
    text: messages.nav.rulesAndDisclaimers,
    link: constants.links.rulesAndDisclaimers,
  },
  {
    text: messages.nav.terms,
    link: constants.links.terms,
  },
  {
    text: messages.nav.policy,
    link: constants.links.policy,
  },
]

const Navbar: React.FC = () => {
  return (
    <div className="flex items-center justify-center mb:items-start mb:justify-start ds:space-x-3 mb:flex-col mb:gap-4">
      {items.map((item, index) => (
        <Href
          key={`${item.link}-${index}`}
          className=""
          href={item.link as string}
          rel="noreferrer"
          target="_blank"
        >
          <Message
            className="text-caption-13 font-medium text-accent-grey-200 hover:text-accent-grey-30 hover:underline"
            value={item.text}
          />
        </Href>
      ))}
    </div>
  )
}

export default Navbar
